import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AdapterService } from 'src/app/core/services/adapter.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CartService } from 'src/app/core/services/cart.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-prompt-modal',
  templateUrl: './login-prompt-modal.component.html',
  styleUrls: ['./login-prompt-modal.component.scss']
})
export class LoginPromptModalComponent implements OnInit {
  form: FormGroup;
  isLoading: boolean = false;
  isSubmitted: boolean = false;

  constructor(public _activeModal: NgbActiveModal,
    private readonly _cartService: CartService,
    private readonly formBuilder: FormBuilder,
    private readonly _toastrService: ToastrService,
    private readonly router: Router,
    private readonly adaptersService: AdapterService,
    private _authService: AuthService) { }

  ngOnInit(): void {
    this.createForm();
  }
  
  close() {
    this._activeModal.close();
  }

  login() {

    this.isSubmitted = true;

    if (this.form.valid) {
      const model: any = {};
    this.isLoading = true;
      model.emailAddress = this.form.controls["email"].value;
      model.password = this.form.controls["password"].value;

      this._authService.login(model).subscribe(response => {
        if (response?.value?.isSuccessful) {
          this.adaptersService.setLocalStorageValue(environment.storageKeys.userInfo, response.value.data);
          this._cartService.notifyCartUpdate(this);
          this._activeModal.close(true);
        }
        else {
          this._toastrService.error(`Error!`);
        }
      }, error => {
          if (error?.value?.message) {
            this._toastrService.error(`${error.value.message}`)
          } else {
            this._toastrService.error(`Error!`)
          }
      });
    }
    else {
      this.isLoading = false;
    }
  }

  refreshLoading() {
    this.isLoading = false;
    this.isSubmitted = false;
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }
}
